// src/components/TaskModal.tsx
import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  Grid,
  Paper,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close"; // Import Close icon
import SubTask from "./Subtasks";
interface Subtask {
  id: string;
  name: string;
  imageUrl?: string;
}

interface TaskModalProps {
  open: boolean;
  onClose: () => void;
  tasksData: any; // Assuming tasksData will be an object with task and task_questions
  onApprove: (
    accountId: string,
    task_id: string,
    status: "approved",
    remarks:null
  ) => void;
  onReject: (
    accountId: string,
    task_id: string,
    status: "rejected",
    remarks:string
  ) => void;
}

const TaskModal: React.FC<TaskModalProps> = ({
  open,
  onClose,
  tasksData,
  onApprove,
  onReject,
}) => {
  console.log("tasksData", tasksData);
  const [showRemarks, setshowRemarks] = useState(false);
  const [remarks, setRemarks] = useState(null);
  const handleClose=()=>{
    setshowRemarks(false)
    setRemarks(null)
    onClose()
  }
  return (
    <Modal
      open={open}
      onClose={() => {}} // Prevent closing on backdrop click
      disableEscapeKeyDown
      sx={{}}
    >
      {
        <Box
          sx={{
            width: "748px",
            bgcolor: "background.paper",
            padding: 4,
            margin: "auto",
            maxHeight: "100%",
            // overflow:'auto',
            marginTop: "12px",
            borderRadius: 2,
            position: "relative", // To position the close button
            height:"100%",
            overflowY:"scroll"
          }}
        >
          {/* Close Button */}
          <IconButton
            onClick={handleClose}
            sx={{ position: "absolute", top: 16, right: 16 }}
          >
            <CloseIcon />
          </IconButton>

          <Typography
            sx={{
              fontSize: "24px",
              lineHeight: "20px",
              fontWeight: "400",
              color: "#000000",
              marginBottom: "16px",
            }}
          >
            Task Details: {tasksData?.task?.task_en}
          </Typography>
          {showRemarks ? (
            <Box sx={{ width: "100%" }}>
              <Typography>Reason :</Typography>
              <TextField
                sx={{
                  width: "100%",
                  borderRadius: "12px !important ",
                  marginBottom: "15px",
                }}
                placeholder="please enter the remark"
                multiline
                onChange={(e: any) => setRemarks(e.target.value)}
                // rows={2}
                // maxRows={4}
              />
            </Box>
          ) : (
            <Box sx={{ marginBottom: 2 }}>
              {/* <Typography variant="h6">Subtasks:</Typography> */}
              <Typography
                sx={{
                  fontSize: "12px",
                  lineHeight: "20px",
                  fontWeight: "400",
                  color: "#7D7D7D",
                }}
              >
                User name:
                {tasksData?.retailer?.name}
                {/* {tasksData.retailer.name} */}
              </Typography>
              <Typography
                sx={{
                  fontSize: "16px",
                  lineHeight: "20px",
                  fontWeight: "400",
                  color: "#565656",
                  marginBottom: "30px",
                }}
              >
                Task: {tasksData?.task?.task_en}
              </Typography>
              <Grid container>
                {tasksData?.task?.task_questions.map((subtask: any) => (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    lg={12}
                    md={12}
                    key={subtask?.question_id}
                  >
                    <SubTask {...subtask} />
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}
          {}

          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "end",
              gap: "24px",
            }}
          >
            {showRemarks && (
              <>
                <Button
                  onClick={() => {
                    setshowRemarks(false);
                  }}
                  sx={{
                    "&.MuiButtonBase-root": {
                      color: "#565656",
                      border: "1px solid #565656",
                      borderRadius: "8px",
                      width: "162px",
                      cursor:
                        tasksData?.approval_status === "rejected"
                          ? "not-allowed"
                          : "pointer",
                      pointerEvents: "unset",
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    remarks && onReject(
                      tasksData.retailer.contact_id,
                      tasksData.task.task_id,
                      "rejected",
                      remarks
                    );
                    handleClose();
                  }}
                  sx={{
                    "&.MuiButtonBase-root": {
                      background:
                        tasksData?.approval_status === "approved"
                          ? "#c8c8c8"
                          : "#4B4B4B",
                      color: "#FFFFFF",
                      border:
                        tasksData?.approval_status === "approved"
                          ? "none"
                          : "1px solid #565656",
                      borderRadius: "8px",
                      width: "162px",
                      cursor:
                        tasksData?.approval_status === "approved"
                          ? "not-allowed"
                          : "pointer",
                      pointerEvents: "unset",
                    },
                  }}
                >
                  Done
                </Button>
              </>
            )}
            {!showRemarks &&
            (tasksData?.approval_status === "approved" ? null : (
              <Button
                disabled={
                  tasksData?.approval_status === "rejected" ? true : false
                }
                onClick={() => {
                  setshowRemarks(true);
                  // onReject(
                  //  tasksData.retailer.contact_id,
                  //   tasksData.task.task_id,
                  //   "rejected"
                  // );
                  // onClose();
                }}
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "#565656",
                    border: "1px solid #565656",
                    borderRadius: "8px",
                    width: "162px",
                    cursor:
                      tasksData?.approval_status === "rejected"
                        ? "not-allowed"
                        : "pointer",
                    pointerEvents: "unset",
                  },
                }}
              >
                {tasksData?.approval_status === "rejected"
                  ? " Rejected"
                  : " Reject"}
              </Button>
            ))}
            {!showRemarks &&
           ( tasksData?.approval_status === "rejected" ? null : (
              <Button
                disabled={
                  tasksData?.approval_status === "approved" ? true : false
                }
                onClick={() => {
                  onApprove(
                    tasksData.retailer.contact_id,
                    tasksData.task.task_id,
                    "approved",
                    null
                  );
                  handleClose();
                }}
                sx={{
                  "&.MuiButtonBase-root": {
                    background:
                      tasksData?.approval_status === "approved"
                        ? "#c8c8c8"
                        : "#4B4B4B",
                    color: "#FFFFFF",
                    border:
                      tasksData?.approval_status === "approved"
                        ? "none"
                        : "1px solid #565656",
                    borderRadius: "8px",
                    width: "162px",
                    cursor:
                      tasksData?.approval_status === "approved"
                        ? "not-allowed"
                        : "pointer",
                    pointerEvents: "unset",
                  },
                }}
              >
                {tasksData?.approval_status === "approved"
                  ? "Approved"
                  : "Approve"}
              </Button>
            ))}
          </Box>
        </Box>
      }
    </Modal>
  );
};

export default TaskModal;
